import dataProvider from '@/api'

/**
 * @description Регистрация, авторизация
 */
export default {
  getFrontSmsToken (payload) {
    return dataProvider.post('/efst', payload)
  },
  /**
   * @description Обычная авторизация пользователя
   *
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%90%D0%B2%D1%82%D0%BE%D1%80%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D1%8F/SimpleAuthLogin
   *
   * @param {object} payload
   * @param {string} payload.phone
   * @param {string} payload.password
   *
   * @returns {object} response
   * @example
   * {
   *   "success": true,
   *   "token": "string",
   *   "profile": {
   *     "id_H": "jAu2",
   *     "last_name": "Doe",
   *     "first_name": "John",
   *     "email": "john@doe.com",
   *     "phone": "string",
   *     "balance": 0,
   *     "is_active": true
   *   },
   *   "is_new": true,
   *   "need_to_fill": true
   * }
   *
   */
  login (payload = {}) {
    return dataProvider.post('/auth/login', payload)
  },

  /**
   * @description Выход из аккаунта пользователя
   *
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%90%D0%B2%D1%82%D0%BE%D1%80%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D1%8F/AuthLogout
   *
   * @returns {object}
   * @example
   * {
   *   "success": {
   *     "success": true
   *   }
   * }
   */
  logout (payload = {}) {
    return dataProvider.post('/authentication/logout', payload)
  },

  /**
   * @description Авторизация пользователя по номеру телефона или регистрация, в случае если пользователь не найден
   * @description registration, register, регистрация
   *
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%90%D0%B2%D1%82%D0%BE%D1%80%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D1%8F/SMSAuthRegistration
   *
   * @param {object} payload
   * @param {object} payload.client
   * @param {object} payload.client.phone
   * @param {object} payload.client.cityId
   * @example
   * {
   *   "client": {
   *     "phone": 79991234567,
   *     "cityId": 1
   *   }
   * }
   *
   * @returns {object}
   * @example 1
   * {
   *   "success": {
   *     "success": true
   *   },
   *   "client": {
   *     "isNew": false
   *   }
   * }
   * @example 2
   * {
   *   "success": false,
   *   "messages": [
   *     "Повторная отправка смс возможна через 1 минуту, подождите или обратитесь в Колл-центр"
   *   ],
   *   "errorCode": 1000
   * }
   */
  sendPhone (payload = {}) {
    return dataProvider.post('/authentication/login', payload)
  },
  loginByCode (payload = {}) {
    return dataProvider.post('/authentication/login', payload)
  },
  sendSms (payload = {}) {
    return dataProvider.post('/authentication/send-sms', payload)
  },
  checkSms (payload = {}) {
    return dataProvider.post('/authentication/check-sms', payload)
  },
  testCode (payload = {}) {
    return dataProvider.post('/authentication/test-code', payload)
  },
  checkToken (payload = {}) {
    return dataProvider.post('/authentication/check-token', payload)
  },

  /**
   * @description Авторизация пользователя через vk
   *
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%90%D0%B2%D1%82%D0%BE%D1%80%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D1%8F/VKAuthLogin
   *
   * @param payload
   * @return {object}
   */
  authVk (payload = {}) {
    return dataProvider.post('/auth/vk', payload)
  },

  /**
   * @description Регистрация пользователя через vk
   *
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%90%D0%B2%D1%82%D0%BE%D1%80%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D1%8F/VKAuthRegistration
   *
   * @param payload
   * @return {object}
   */
  vkRegister (payload = {}) {
    return dataProvider.post('/auth/vk/register', payload)
  },

  /**
   * @description Авторизация пользователя через facebook
   *
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%90%D0%B2%D1%82%D0%BE%D1%80%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D1%8F/FacebookAuthLogin
   *
   * @param payload
   * @return {object}
   */
  authFacebook (payload = {}) {
    return dataProvider.post('/auth/facebook', payload)
  },

  /**
   * @description Регистрация пользователя через facebook
   *
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%90%D0%B2%D1%82%D0%BE%D1%80%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D1%8F/FacebookAuthRegistration
   *
   * @param payload
   * @return {object}
   */
  facebookRegister (payload = {}) {
    return dataProvider.post('/auth/facebook/register', payload)
  },

  /**
   * @description Авторизация пользователя через apple
   *
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%90%D0%B2%D1%82%D0%BE%D1%80%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D1%8F/AppleAuthLogin
   *
   * @param payload
   * @return {object}
   */
  authApple (payload = {}) {
    return dataProvider.post('/auth/apple', payload)
  },

  /**
   * @description Регистрация пользователя через apple
   *
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%90%D0%B2%D1%82%D0%BE%D1%80%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D1%8F/AppleAuthRegistration
   *
   * @param payload
   * @return {object}
   */
  appleRegister (payload = {}) {
    return dataProvider.post('/auth/apple/register', payload)
  },

  /**
   * @description Возможность использования приложения без авторизации
   *
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%90%D0%B2%D1%82%D0%BE%D1%80%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D1%8F/AuthPreauth
   *
   * @param payload
   * @return {object}
   */
  getPreAuth (payload = {}) {
    return dataProvider.get('/auth/preauth', payload)
  },
  /**
   * @description Получение профиля
   *
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=PersonalCabinet%201.1#/%D0%9A%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D1%81%D0%BA%D0%B8%D0%B9%20%D0%BF%D1%80%D0%BE%D1%84%D0%B8%D0%BB%D1%8C/ClientProfileShow
   *
   * @param payload
   * @return {object}
   */
  getProfile (payload = {}) {
    return dataProvider.get('/clients/profile', { brandId: 1, ...payload })
  },
}
